/**
 * Layout: minimal — media and title, nothing else.
 *
 * For rails where the click destination is the point: related items, recently
 * viewed, editorial strips. Price and a CTA would compete with the primary
 * product on the page, so both are deliberately absent.
 *
 * No actions slot at all — which is also why the grid's cart-state patching
 * falls back to a full redraw here (see grid._updateCartState).
 */

import { el } from '../../dom.js';
import { renderMedia } from './_shared.js';
import { cardRoot } from './root.js';

export function render(model, ctx) {
	const body = el('div', { class: 'card-body rfhq-pc-body' }, [
		el('a', { href: model.href }, [
			el('div', { class: 'product-title rfhq-pc-title', itemprop: 'name', text: model.title }),
		]),
	]);

	return cardRoot(model, ctx, 'minimal', [renderMedia(model), body]);
}
